<div style="background-color: #F5F7F8; height: 100vh; overflow: hidden;">
    <div style="background-color: #F5F7F8; height: 87vh; overflow-y: scroll;">
        <div style="position: relative;">
            <span (click)="this.back()" style="width: 41px;z-index: 1000;height: 41px;position: absolute;top: 18px;left: 19px;padding: 7px;border: 2px solid #E9EBF0;border-radius: 30px;">
                <img style="z-index: 1000000; width: 22px; height: 22px;" (click)="this.back()" src="/assets/images/shared/back.svg">
            </span>
            <span style="width: 41px;z-index: 1000;height: 41px;position: absolute;top: 18px;padding: 7px;right: 19px;border: 2px solid #E9EBF0;border-radius: 30px;">
                <img (click)="this.share()" style="z-index: 1000; width: 22px" src="/assets/images/product/icon-share.svg"/>
            </span>
            <span style="width: 41px;z-index: 1000;height: 41px;position: absolute;top: 68px;padding: 7px;right: 19px;border: 2px solid #E9EBF0;border-radius: 30px;">
                <img (click)="this.toggleFavourite()" style="z-index: 10000; width: 22px;" [src]="(this.isFavourite) ? '/assets/images/product/added-to-fav.svg' : '/assets/images/product/add-to-fav.svg'"/>
            </span>
        </div>
        <div style="width: 100%; margin: auto; background-color: white; padding: 10px;">
            <ngb-carousel [interval]="0" #carouseltoggle class="carousel slide carousel-fade"  data-interval="false" data-touch="true" data-ride="carousel"  style="width: 100%; display: inline-block; height: 100%;" *ngIf="this.productImages.data.length" [showNavigationArrows]="false" [showNavigationIndicators]="true">
                <ng-template ngbSlide *ngFor="let image of this.productImages.data">
                  <div class="picsum-img-wrapper">
                    <img (touchstart)="posIni = $event.changedTouches[0].pageX" (touchend)="move($event.changedTouches[0].pageX, carouseltoggle)" (click)="this.onImageClick(carousel, carouseltoggleGallery, image)" [src]="image.original.url" style="width: 250px; height: 250px;" alt="Random slide">
                  </div>
                </ng-template>
            </ngb-carousel>
        </div>

        <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">

            <div class="row" style="margin-top: 12px;">
                <div class="col-9" style="text-align: left;">
                    <p style="font-weight: 800; padding-bottom: 0px; margin-bottom: 10px;">{{ this.product?.name }}</p>
                  <div class="group-info-top-price-row">
                    <span class="group-info-old-price">
                      <app-price
                        class="group-info-old-price-value"
                        [amount]="getStandardUnitPriceBase()"
                        layout="inline"
                      ></app-price>
                    </span>

                    <app-price
                      class="group-info-current-price"
                      [amount]="getDiscountedUnitPriceBase()"
                      layout="inline"
                    ></app-price>
                  </div>
                </div>
                <div class="col-3 justify-content-center align-self-center">
                    <button (click)="this.goToProduct(this.product?.uuid || '')" type="button" class="btn btn-primary align-items-center" style="background-color: #E4F2FE; color: #0A69EB; border: none;" >Виж</button>
                </div>
            </div>
        </div>

        <div *ngIf="this.variations.length > 1" style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <div *ngIf="this.colors.length">
                <p style="font-weight: bold; width: 80%; display: inline-block;">Избери цвят: <span style="color: #0A69EB;">{{ this.selectedColor }}</span></p>
                <div>
                    <img *ngFor="let variation of this.filteredVariations" (click)="this.selectItem(variation.uuid)" class="rounded-circle" [style]="(variation.uuid == this.selectedItemUUID) ? 'border: 2px solid #0A69EB; padding: 3px; height: 40px; width: 40px; display: inline-block; margin: 10px;' : ' height: 40px; width: 40px; display: inline-block; margin: 10px;'" [src]="this.variationImageURL(variation.uuid)"/>
                </div>
            </div>
            <p  *ngIf="this.sizes.length" style="font-weight: bold; width: 80%; display: inline-block;">Избери размер:</p>
            <br>
            <span *ngIf="this.colors.length">
                <span *ngFor="let size of this.filteredSizes" [style]="(size.uuid == this.selectedSizeUUID) ? 'border: 1px solid #0A69EB; margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E4F2FE; font-weight: 700; text-align: center; border-radius: 10px;' : 'margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E9EBF0; font-weight: 700; text-align: center; border-radius: 10px;'" (click)="this.selectSize(size.uuid)">{{ size.value }}</span>
            </span>
            <span *ngIf="!this.colors.length">
                <span *ngFor="let size of this.sizes"  [style]="(size.uuid == this.selectedSizeUUID) ? 'border: 1px solid #0A69EB; margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E4F2FE; font-weight: 700; text-align: center; border-radius: 10px;' : 'margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E9EBF0; font-weight: 700; text-align: center; border-radius: 10px;'"  (click)="this.selectSize(size.uuid)" style="margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E9EBF0; font-weight: 700; text-align: center; border-radius: 10px;">{{ size.value }}</span>
            </span>

        </div>


        <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">

            <div class="row" style="margin-top: 12px;">
                <div class="col-9" style="text-align: left;">
                    <p style="font-weight: bold; padding-bottom: 0px; margin-bottom: 2px;">Оставащо време:</p>
                    <p style="color: #ADAFBB; font-size: 9px; margin-bottom: 0px;">Всяка групова поръчка има валидност 24 часа</p>
                </div>
                <div class="col-3" style="text-align: center; color: #0A69EB; font-weight: bold;">{{ this.groupTime }}</div>
            </div>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
            <div class="row" style="margin-top: 12px;">
                <div class="col-9" style="text-align: left;">
                    <p style="font-weight: bold; padding-bottom: 0px; margin-bottom: 2px;">Налично количество:</p>
                </div>
                <div class="col-3" style="text-align: center; color: #0A69EB; font-weight: bold;">{{ this.product?.total_available_quantity }}</div>
            </div>
        </div>

        <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">
                    <p style="font-size: 14px; font-weight: bold; width: 80%; display: inline-block;">{{ 'Членове (' + this.group?.data?.participants?.length + ")" }}</p>
                </div>
                <div class="col-6" style="font-weight: bold; text-align: right">
                    <p style=" font-size: 14px; display: inline-block;">{{ 'Количество (' + this.group?.data?.quantity_reserved + ' бр.)' }}</p>
                </div>
            </div>

            <div class="row" style="margin-top: 12px;" *ngFor="let participant of this.group?.data?.participants">

                <div class="col-2 justify-content-center align-self-center" style="text-align: left;">
                    <img style=" width: 50px; height: 50px;" class="rounded-circle avatar" [src]="participant.participant.imageURL"/>
                </div>


                <div class="col-7 justify-content-center align-self-center" style="text-align: left;">
                    <p style="font-size: 14px; margin-bottom: 0px;">
                        {{ participant.participant?.fist_name +  ' ' + participant.participant?.last_name }}
                    </p>
                </div>
                <div class="col-3 justify-content-center align-self-center" style="font-weight: bold; text-align: right">
                    <button disabled type="button" class="btn btn-primary" style="width: 65px; border: none; background-color: #F9FAFB; color: #79798B;" >
                        {{ participant.quantity }}
                    </button>
                </div>
            </div>
        </div>

        <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <p style="font-weight: bold; width: 80%; display: inline-block;">Ценоразпис</p>
            <div *ngFor="let pricing of this.product?.pricing" class="row group-info-pricing-row">
              <span class="col-4 group-info-pricing-range">
                {{ (pricing.quantity_to == pricing.quantity_from) ? this.getFullAmountLabel(pricing.quantity_from) : pricing.quantity_from }}
                <span>{{ (pricing.quantity_to != pricing.quantity_from) ? ('- ' + this.getFullAmountLabel(pricing.quantity_to)) : "" }}</span>
              </span>
              <span [class]="(pricing.quantity_from > 1) ? 'col-6 group-info-pricing-value' : 'col-7 group-info-pricing-value'">
                <app-price
                  [amount]="getPricingAmountBase(pricing.price_per_piece)"
                  layout="inline"
                ></app-price>
                <span>/бр.</span>
              </span>
              <span *ngIf="(pricing.quantity_from > 1)" class="bg-primary col-1 group-info-pricing-discount-badge">
                {{ this.calculateDiscount(this.getPricingFor(1), pricing.price_per_piece) }}
              </span>
            </div>
            <div class="row group-info-pricing-row">
              <span class="col-4 group-info-pricing-range">{{ 'над ' + this.maxAmountForPricing + ' броя' }}</span>
              <span class="col-7 group-info-pricing-value">
                <app-price
                  [amount]="getPricingAmountBase(this.minPriceForPricing)"
                  layout="inline"
                ></app-price>
                <span>/бр.</span>
              </span>
            </div>
        </div>

        <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <p style="font-weight: bold; width: 80%; display: inline-block; margin-bottom: 5px;">Доставка:</p>
            <p class="group-info-delivery-free-label">
              Безплатна за поръчки над
              <app-price
                [amount]="getFreeDeliveryThresholdBase()"
                layout="inline"
              ></app-price>!
            </p>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
            <div class="group-info-delivery-row">
              <span style="width: fit-content;">Изпращане до офис на куриер:</span>
              <span class="group-info-delivery-value">
                <app-price
                  [amount]="getCourierOfficeDeliveryBase()"
                  layout="inline"
                  fontWeight="normal"
                ></app-price>
              </span>
            </div>
            <div class="group-info-delivery-row">
              <span style="width: fit-content;">Изпращане до адрес:</span>
              <span class="group-info-delivery-value">
                <app-price
                  [amount]="getAddressDeliveryBase()"
                  layout="inline"
                  fontWeight="normal"
                ></app-price>
              </span>
            </div>
        </div>
    </div>
    <div style="position: fixed; bottom: 0px; text-align: center; width: 100%; left: 0px;  background-color: #F5F7F8;">
        <button *ngIf="this.group" type="button" class="btn btn-primary" style="width: 90%; margin: auto; height: 45px;" (click)="this.join(login)">Включи се и спести {{ this.nextPercent }}</button>
        <p style="color: #ADAFBB; font-size: 10px; width: 95%; margin: auto; margin-bottom: 3px;">Крайната цена зависи от броя заявено количество за продукта от присъединилите се в групата.</p>
    </div>
</div>


<ng-template #carousel let-modal>
  <div class="modal-header group-info-gallery-header">
    <button
      type="button"
      class="btn-close group-info-gallery-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body group-info-gallery-body">
    <ngb-carousel
      *ngIf="this.productImages.data.length"
      #carouseltoggleGallery
      [activeId]="this.getActiveIdForImageCarousel()"
      [interval]="0"
      [showNavigationArrows]="false"
      [showNavigationIndicators]="true"
      class="carousel slide carousel-fade group-info-gallery-carousel"
      data-interval="false"
      data-touch="true"
      data-ride="carousel"
    >
      <ng-template
        ngbSlide
        *ngFor="let image of this.productImages.data; let i = index"
        id="{{ i }}"
      >
        <div class="group-info-gallery-slide">
          <img
            class="group-info-gallery-image"
            [src]="image.original.url"
            alt="Product image"
            loading="eager"
            decoding="async"
            (touchstart)="posIni = $event.changedTouches[0].pageX"
            (touchend)="move($event.changedTouches[0].pageX, carouseltoggleGallery)"
          />
        </div>
      </ng-template>
    </ngb-carousel>
  </div>
</ng-template>

<ng-template #login let-modal>
    <div style="text-align: center;">
        <img src="/assets/images/account/image-login.png" alt="" style="height: 140px; width: 160px; margin-top: 30px; margin-bottom: 20px;"> <br>
        <p style="font-weight: bold; margin-top: 7px;">Влез в профила си за да продължиш</p>
    </div>
    <div *ngIf="!this.goToMobileApp" class="row" style="margin-top: 25px; margin-bottom: 15px;">
        <div class="col-6" style="text-align: center;">
            <button class="btn btn-primary" style="border-color: transparent; width: 90%; background-color: #E4F2FE; color: #0A69EB" mat-button (click)="this.registration(modal)">Регистрация</button>
        </div>
        <div class="col-6" style="text-align: center;">
            <button class="btn btn-primary" style="width: 90%;"  mat-button (click)="this.loginNavigation(modal)">Влез</button>
        </div>
    </div>
    <div *ngIf="this.goToMobileApp" class="row" style="margin-top: 25px; margin-bottom: 15px;">
        <div class="col-12" style="text-align: center;">
            <button class="btn btn-primary" style="border-color: transparent; width: 90%; background-color: #E4F2FE; color: #0A69EB" mat-button (click)="this.goToGooglePlay()">Свалете приложението</button>
        </div>
    </div>
  </ng-template>
